import React, { memo, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridItem from 'components/Grid/GridItem';
import useLayerContext from 'contexts/layerContext';

const useStyles = makeStyles(() => ({
  fieldset: {
    position: 'relative',
    marginBottom: '10px',
  },
  legend: {
    position: 'absolute',
    margin: '0',
    top: '-15px',
    backgroundColor: 'white',
  },
  legendDiv: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  contLegend: {
    display: 'flex',
    fontWeight: 'bold',
    zIndex: 9000,
    '& img': {
      height: '100%',
    },
    '& span': {
      marginLeft: '5px',
      color: 'black',
    },
  },
}));

// Aprox .333
const hexaAlpha = '55';

function LayerLegend(props) {
  const { extraLayers, title = 'Capas', style, type = 'layer', usePropsLayer = false } = props;
  const { filteredLayers } = useLayerContext();
  const classes = useStyles();

  let layers = useMemo(() => {
    if (usePropsLayer === true && props.layers !== undefined) return props.layers;

    if (extraLayers === undefined) return filteredLayers;
    return [...extraLayers, ...filteredLayers];
  }, [extraLayers, filteredLayers]);

  return (
    <GridItem xs={12} sm={12} md={12}>
      <fieldset className={classes.fieldset} style={style}>
        <legend className={classes.legend}>{title}</legend>
        <div className={classes.legendDiv}>
          {layers.map((layer, index) => {
            if (type === 'layer') {
              return (
                <div className={classes.contLegend} key={index}>
                  <div
                    style={{
                      height: '20px',
                      width: '40px',
                      borderRadius: '5px',
                      marginRight: '15px',
                      backgroundColor:
                        layer?.color === undefined ? undefined : layer.color + hexaAlpha,
                      border: layer.color === undefined ? undefined : '2px solid black',
                    }}
                  ></div>
                  <span>{layer.name}</span>
                </div>
              );
            } else {
              return (
                <div className={classes.contLegend} key={index}>
                  <img src={layer.color} style={{ height: '30px' }} />
                  <span>{layer.name}</span>
                </div>
              );
            }
          })}
        </div>
      </fieldset>
    </GridItem>
  );
}

export default memo(LayerLegend);
